import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { CLIENT_DOWNLOADS_LIST, CLIENT_DOWNLOADS_LIST_SUCCESS, CLIENT_DOWNLOADS_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClientDownloadsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/downloadsInfo`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...payload?.headers,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: CLIENT_DOWNLOADS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CLIENT_DOWNLOADS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENT_DOWNLOADS_LIST_ERROR, payload: error });
  }
}

export function* watchClientDownloadsList() {
  yield takeEvery(CLIENT_DOWNLOADS_LIST, getClientDownloadsList);
}

function* clientDownloadsListSaga() {
  yield all([fork(watchClientDownloadsList)]);
}

export default clientDownloadsListSaga;
